var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { warehouse as api } from '../../../api';
import { useNotify } from '../../../hooks/notificationHook';
import { FormikTextField } from '../../atoms/TextField';
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import { camelize } from '../../../utils/camelize';
import { FormikSelectField } from '../../atoms/SelectField';
import { currencyItems } from '../../../constants/currency';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import CurrencyTextField from '../../organisms/CurrencyTextField';
import useFormikTextField from '../../../hooks/hoc/useFormikTextField';
import { useNavigate } from 'react-router-dom';
var REQUIRED_FIELDS = [
    'name',
    'email',
    'shipping_company_email',
    'mail_send_time_jst',
    'currency',
    'unit_price',
    'import_tax_rate',
];
var AdminWarehouseDetailPage = function (_a) {
    var warehouse = _a.warehouse;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var create = useRequest(api.create);
    var update = useRequest(api.update);
    var navigate = useNavigate();
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    request = warehouse.id
                        ? update({ id: warehouse.id, warehouse: values })
                        : create({ warehouse: values });
                    return [4 /*yield*/, request];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    navigate("/admin/warehouses/".concat(response.id));
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, warehouse, create, update, notify, navigate]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (values[field] === null ||
                values[field] === undefined ||
                values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.warehouse.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var formik = useFormik({
        initialValues: toFormikValue(warehouse),
        onSubmit: onSubmit,
        validate: validate,
        validateOnMount: true,
        validateOnChange: true,
        enableReinitialize: true,
    });
    var FormikCurrencyTextField = useFormikTextField(CurrencyTextField);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, name: "name", label: t('params.warehouse.name'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "email", label: t('params.warehouse.email'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "shipping_company_email", label: t('params.warehouse.shippingCompanyEmail'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "mail_send_time_jst", label: t('params.warehouse.mailSendTimeJst'), items: mailSendTimeJstItems, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikSelectField, { fullWidth: true, name: "currency", label: t('params.warehouse.currency'), items: currencyItems, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikCurrencyTextField, { fullWidth: true, name: "unit_price", label: t('params.warehouse.unitPrice'), currency: formik.values.currency, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormikTextField, { fullWidth: true, type: "number", name: "import_tax_rate", label: t('params.warehouse.importTaxRate'), required: true, formik: formik })),
            shippingTextFields.map(function (_a) {
                var name = _a.name, multiline = _a.multiline;
                return (React.createElement(Grid, { item: true, key: name, xs: multiline ? 12 : 6 },
                    React.createElement(FormikTextField, { fullWidth: true, multiline: multiline, rows: multiline ? 3 : 1, name: name, label: t("params.warehouse.".concat(camelize(name))), formik: formik })));
            }),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.update'))))));
};
export default AdminWarehouseDetailPage;
var toFormikValue = function (warehouse) { return ({
    name: warehouse.name,
    email: warehouse.email,
    shipping_company_email: warehouse.shippingCompanyEmail,
    mail_send_time_jst: warehouse.mailSendTimeJst,
    currency: warehouse.currency,
    unit_price: warehouse.unitPrice,
    import_tax_rate: warehouse.importTaxRate,
    default_delivery_company: warehouse.defaultDeliveryCompany,
    default_tracking_url: warehouse.defaultTrackingUrl,
    building_name: warehouse.buildingName,
    building_name_en: warehouse.buildingNameEn,
    address: warehouse.address,
    address_en: warehouse.addressEn,
    airport: warehouse.airport,
    seaport: warehouse.seaport,
    consignee_company_name: warehouse.consigneeCompanyName,
    consignee_contact_name: warehouse.consigneeContactName,
    consignee_address: warehouse.consigneeAddress,
    consignee_phone_number: warehouse.consigneePhoneNumber,
    consignee_email: warehouse.consigneeEmail,
    consignee_tax_id_text: warehouse.consigneeTaxIdText,
    notify_party_company_name: warehouse.notifyPartyCompanyName,
    notify_party_contact_name: warehouse.notifyPartyContactName,
    notify_party_address: warehouse.notifyPartyAddress,
    notify_party_phone_number: warehouse.notifyPartyPhoneNumber,
    notify_party_email: warehouse.notifyPartyEmail,
    notify_party_tax_id_text: warehouse.notifyPartyTaxIdText,
}); };
var mailSendTimeJstItems = Array.from(Array(24).keys()).reduce(function (listItems, hour) {
    var hourString = String(hour).padStart(2, '0');
    ['00', '10', '20', '30', '40', '50'].forEach(function (minute) {
        var item = "".concat(hourString, ":").concat(minute);
        listItems.push({ text: item, value: item });
    });
    return listItems;
}, []);
var shippingTextFields = [
    { name: 'default_delivery_company', multiline: false },
    { name: 'default_tracking_url', multiline: false },
    { name: 'building_name', multiline: false },
    { name: 'building_name_en', multiline: false },
    { name: 'address', multiline: false },
    { name: 'address_en', multiline: false },
    { name: 'airport', multiline: false },
    { name: 'seaport', multiline: false },
    { name: 'consignee_company_name', multiline: false },
    { name: 'consignee_contact_name', multiline: false },
    { name: 'consignee_address', multiline: false },
    { name: 'consignee_phone_number', multiline: false },
    { name: 'consignee_email', multiline: false },
    { name: 'consignee_tax_id_text', multiline: true },
    { name: 'notify_party_company_name', multiline: false },
    { name: 'notify_party_contact_name', multiline: false },
    { name: 'notify_party_address', multiline: false },
    { name: 'notify_party_phone_number', multiline: false },
    { name: 'notify_party_email', multiline: false },
    { name: 'notify_party_tax_id_text', multiline: true },
];
